import React from 'react';

import '../assets/css/Header.css';

import logo from "../assets/images/white-logo.svg";

function Header({
                    component,
                    addAdminButton,
                    addClientButton,
                    addUserButton,
                    selectedClients,
                    sendReminderButton,
                    selectedClient,
                    selectedFiles,
                    downloadFilesButton,
                    basicUser
                }) {
    return (
        <div className='navbar'>
            <div className="mobile-header">
                <button className="navbar-toggler vertical-nav-button" type="button"
                        data-bs-toggle="offcanvas" data-bs-target="#verticalNavbar"
                        aria-controls="verticalNavbar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                         className="bi bi-list" viewBox="0 0 16 16">
                        <path fillRule="evenodd"
                              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                    </svg>
                </button>
                <img src={logo} alt="Logo"/>
            </div>
            <h1 className='navbar-heading'>{component}</h1>
            <div className="header-button-container">
                {component === "Manage Admins" && [
                    <button className='black-button' key="add-admin-button" onClick={() => addAdminButton()}>
                        + Add Admin
                    </button>,
                ]}
                {(component === "Manage Clients" || component === "Favorite Clients") && [
                    <button className='blue-button' key="send-reminder-button" disabled={selectedClients.length === 0}
                            onClick={() => sendReminderButton()}>
                        Send Reminder ({selectedClients.length})
                    </button>,
                    <button className='black-button' key="add-client-button" onClick={() => addClientButton()}>
                        + Add Client
                    </button>,
                ]}
                {(component === "Manage Client" && selectedClient && selectedClient.hasOwnProperty('id')) && [
                    <button className='black-button' key="add-user-button" onClick={() => addUserButton()}>
                        + Add User
                    </button>,
                ]}
                {((component === "Dashboard" || component === "Favorites") && selectedClient) && [
                    <button className='grey-button' key="send-reminder-button" disabled={selectedFiles.length === 0}
                            onClick={() => downloadFilesButton()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path
                                d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                            <path fillRule="evenodd"
                                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                        </svg>
                        Download
                    </button>,
                    basicUser ?
                        <button className='black-button' data-bs-toggle="modal"
                                data-bs-target={component === "Favorites" ? "#newFavoriteFileModal" : "#newFileModal"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                 className="bi bi-plus-lg" viewBox="0 0 16 16">
                                <path fillRule="evenodd"
                                      d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                            </svg>
                            Upload File
                        </button>
                        : <div className="dropdown" key="add-new-button">
                            <button className='black-button' data-bs-toggle="dropdown" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                     className="bi bi-plus-lg" viewBox="0 0 16 16">
                                    <path fillRule="evenodd"
                                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                </svg>
                                New
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#newFolderModal">
                                        Folder
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#newFileModal">
                                        Files
                                    </a>
                                </li>
                            </ul>
                        </div>,
                ]}
            </div>
            <div className="d-flex mobile-header-container">
                <h1 className='navbar-heading'>{component}</h1>
                <div
                    className={"header-button-container" + ((component === "Manage Clients" || component === "Favorite Clients" || component === "Dashboard" || component === "Favorites") ? " clients-header-button-container" : "")}>
                    {component === "Manage Admins" && [
                        <button className='black-button' key="add-admin-button" onClick={() => addAdminButton()}>
                            + Add Admin
                        </button>,
                    ]}
                    {(component === "Manage Clients" || component === "Favorite Clients") && [
                        <button className='blue-button desktop-send-reminder-container' key="send-reminder-button"
                                disabled={selectedClients.length === 0}
                                onClick={() => sendReminderButton()}>
                            Send Reminder ({selectedClients.length})
                        </button>,
                        <button className='black-button' key="add-client-button" onClick={() => addClientButton()}>
                            + Add Client
                        </button>,
                    ]}
                    {(component === "Manage Client" && selectedClient && selectedClient.hasOwnProperty('id')) && [
                        <button className='black-button' key="add-user-button" onClick={() => addUserButton()}>
                            + Add User
                        </button>,
                    ]}
                    {((component === "Dashboard" || component === "Favorites") && selectedClient) && [
                        <button className='grey-button' key="send-reminder-button" disabled={selectedFiles.length === 0}
                                onClick={() => downloadFilesButton()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 className="bi bi-pencil-square" viewBox="0 0 16 16">
                                <path
                                    d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                <path fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                            </svg>
                            Download
                        </button>,
                        basicUser ?
                            <button className='black-button' data-bs-toggle="modal"
                                    data-bs-target={component === "Favorites" ? "#newFavoriteFileModal" : "#newFileModal"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                     className="bi bi-plus-lg" viewBox="0 0 16 16">
                                    <path fillRule="evenodd"
                                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                </svg>
                                Upload File
                            </button>
                            : <div className="dropdown" key="add-new-button">
                                <button className='black-button' data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                         className="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fillRule="evenodd"
                                              d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                    </svg>
                                    New
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a className="dropdown-item" data-bs-toggle="modal"
                                           data-bs-target="#newFolderModal">
                                            Folder
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#newFileModal">
                                            Files
                                        </a>
                                    </li>
                                </ul>
                            </div>,
                    ]}
                </div>
            </div>
        </div>
    );
}

export default Header;
